import script from "./readingRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./readingRecord.vue?vue&type=script&setup=true&lang=js"

import "./readingRecord.vue?vue&type=style&index=0&id=0fe4bf91&lang=scss&scoped=true"

import exportComponent from "/root/workspace/public_sso_CS39/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fe4bf91"]])

export default __exports__